import { Box } from '@mui/material';
import { useState } from 'react';
import Header from '../dashboard/Header';
import AdminSideDrawer from './AdminSideDrawer';

interface AdminLayoutProps {
  children: React.ReactNode;
}

const AdminLayout = ({ children }: AdminLayoutProps) => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const toggleSidebar = () => setSidebarOpen((open) => !open);

  return (
    <Box sx={{ display: 'flex' }}>
      <Header onToggleSidebar={toggleSidebar} open={sidebarOpen} />
      <AdminSideDrawer open={sidebarOpen} />
      <Box component="main" sx={{ flexGrow: 1, pt: 8 }}>
        {children}
      </Box>
    </Box>
  );
};

export default AdminLayout; 